import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b188fcbc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b188fcbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b188fcbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b188fcbc')) {
      api.createRecord('b188fcbc', component.options)
    } else {
      api.reload('b188fcbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b188fcbc&scoped=true", function () {
      api.rerender('b188fcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignTasks/index.vue"
export default component.exports